import { useEffect, useState } from "react";
import { lastMinuteService } from "../../services/lastMinuteService";

// The composer picker source (Invariant 1: own roster only). Returns the agent's
// own players + represented staff/coaches. No free-text players — an empty roster
// routes the user to My Players instead.
export const useRoster = (open) => {
  const [roster, setRoster] = useState({ players: [], staff: [], coaches: [] });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!open) return undefined;
    const controller = new AbortController();
    setLoading(true);
    lastMinuteService
      .getRoster(controller.signal)
      .then((res) => {
        if (res.success) {
          setRoster({
            players: res.data.players || [],
            staff: res.data.staff || [],
            coaches: res.data.coaches || [],
          });
          setError(null);
        } else {
          setError(res.error);
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false));
    return () => controller.abort();
  }, [open]);

  return { roster, loading, error };
};

export default useRoster;
